var _excluded = ["initialSearchResult"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { EventBoundary, withSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import AllhomesTabbedPanel from '@domain-group/fe-co-allhomes-tabbed-panel';
import { getQueryStringValue, setQueryStringValue } from '@domain-group/fe-allhomes-library';
import AllhomesListingCardPane from './allhomes-listing-card-pane';
import * as events from '../models/events';
import * as styles from './allhomes-listing-card-tabs.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class BaseAllhomesListingCardsTabs extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "listingCardClicked", listingId => {
      var _this$props$eventHand, _this$props$eventHand2;
      (_this$props$eventHand = (_this$props$eventHand2 = this.props.eventHandlers).listingCardClicked) === null || _this$props$eventHand === void 0 ? void 0 : _this$props$eventHand.call(_this$props$eventHand2, listingId, this.props.tabs[this.state.activeTabIndex]);
    });
    _defineProperty(this, "tabClickedHandler", (activeTab, activeTabIndex) => {
      this.props.sendEvent([events.tabsPrefix, events.tabSelect], {
        tab: activeTab.id
      });
      this.setState({
        activeTabIndex
      });
      if (this.props.eventHandlers && this.props.eventHandlers.tabClicked) {
        this.props.eventHandlers.tabClicked(activeTab);
      }
      setQueryStringValue({
        tab: activeTabIndex,
        page: 1
      }, true);
    });
    _defineProperty(this, "showAllClickedHandler", tabId => {
      if (this.props.eventHandlers && this.props.eventHandlers.showAllClicked) {
        this.props.eventHandlers.showAllClicked(tabId);
      }
    });
    _defineProperty(this, "showLessClickedHandler", tabId => {
      if (this.props.eventHandlers && this.props.eventHandlers.showLessClicked) {
        this.props.eventHandlers.showLessClicked(tabId);
      }
    });
    _defineProperty(this, "buildPanel", tabProp => {
      if (tabProp && tabProp.totalCount && tabProp.initialSearchResult) {
        var eventHandler = this.props.eventHandlers && this.props.eventHandlers.listingCardClicked ? {
          listingCardClicked: this.listingCardClicked
        } : {};
        var initialSearchResult = tabProp.initialSearchResult,
          otherTabProps = _objectWithoutProperties(tabProp, _excluded);
        return {
          tab: otherTabProps,
          content: ___EmotionJSX(EventBoundary, {
            data: {
              tab: tabProp.id
            }
          }, ___EmotionJSX("div", {
            css: styles.subTitle
          }, ___EmotionJSX("span", null, tabProp.subTitle), tabProp.duration && ___EmotionJSX("span", {
            css: styles.duration
          }, tabProp.duration)), ___EmotionJSX(AllhomesListingCardPane, _extends({
            id: tabProp.id,
            requestType: tabProp.id,
            sourceId: this.props.sourceId,
            sourceType: this.props.sourceType,
            totalListingsCount: tabProp.totalCount,
            initialSearchResult: initialSearchResult
          }, eventHandler, {
            includeStructuredData: this.props.includeStructuredData,
            onShowAll: this.showAllClickedHandler,
            onShowLess: this.showLessClickedHandler
          })))
        };
      }
      return false;
    });
    this.state = {
      activeTabIndex: this.props.activeTabIndex || 0
    };
  }
  componentDidMount() {
    var queryStringValue = getQueryStringValue('tab', "".concat(this.props.activeTabIndex || 0));
    var activeTabIndex = parseInt("".concat(Array.isArray(queryStringValue) ? queryStringValue[0] : queryStringValue), 10);
    this.setState({
      activeTabIndex
    });
  }
  render() {
    var tabsWithPanels = this.props.tabs.reduce((result, tab) => {
      var panel = this.buildPanel(tab);
      if (panel) {
        result.push(panel);
      }
      return result;
    }, []);
    if (isEmpty(tabsWithPanels)) {
      return false;
    }
    var titleTag = null;
    if (this.props.titleTagType === 'h2') {
      titleTag = ___EmotionJSX("h2", null, this.props.title);
    } else {
      titleTag = ___EmotionJSX("h4", null, this.props.title);
    }
    return ___EmotionJSX("div", {
      className: this.props.className
    }, ___EmotionJSX("div", {
      css: styles.header
    }, titleTag), ___EmotionJSX(AllhomesTabbedPanel, {
      css: styles.tabList,
      tabWrapper: ___EmotionJSX("div", {
        css: styles.tabbedPanelContainer
      }),
      key: this.state.activeTabIndex,
      activePanelIndex: this.state.activeTabIndex,
      className: "allhomes-listing-card__list-tabs",
      panels: tabsWithPanels,
      onTabClick: this.tabClickedHandler,
      itemCountShape: "rectangle",
      tabColour: styles.tabColour,
      tabCountColour: styles.tabCountColour,
      tabInactiveColour: styles.tabInactiveColour,
      tabBorderColour: styles.tabBorderColour
    }));
  }
}
_defineProperty(BaseAllhomesListingCardsTabs, "defaultProps", {
  titleTagType: 'h4',
  title: 'Listings',
  activeTabIndex: 0,
  includeStructuredData: true,
  sendEvent: () => {}
});
export var AllhomesListingCardsTabs = withSendEvent(BaseAllhomesListingCardsTabs);